import { MIXPANEL_TOKENS } from './mixpanel-tokens';
import { parseBooleanEnv } from './utils';

export const environment = {
  apiBaseUrl: 'https://qa.api.sbv360.com',
  reportsApiUrl:
    'https://report-generator-api-qa-dghrecefbdajceag.eastus-01.azurewebsites.net',
  chatPublicKey: '7j2r5n773wxu',
  environment: 'qa',
  mixpanelToken: MIXPANEL_TOKENS.NON_PRODUCTION as string | undefined,
  enablePBJ: parseBooleanEnv(process.env.NX_FEATURE_FLAG_PBJ_ENABLED, true),
};
